import { ESdChangeReason, IAction, IConditionModel } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaSmallMediumText from "../../../ui-kit/typography/SmallMediumText/SmallMediumText";
import { Comparison } from "./condition";

export interface IActionConditionPickerState {
  active: boolean;
}

export interface IActionConditionPickerProps {
  action: IAction;
  condition?: IConditionModel;
  onChange?: (condition?: IConditionModel, changeReason?: ESdChangeReason | undefined) => void;
  dontShowRemoveCondition?: boolean;
}

class ActionCondition extends PureSdComponent<
  IActionConditionPickerProps & IWithSDProps & IWithContextProp,
  IActionConditionPickerState
> {
  constructor(props: IActionConditionPickerProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  handleRemoveCondition = () => {
    if (this.props.onChange) {
      this.props.onChange(undefined);
    }
  };

  render() {
    return (
      <>
        {this.props.condition && (
          <>
            <div className="kuika-right-panel__row" style={{ marginTop: 4, marginBottom: "-12px" }}>
              <div className="kuika-right-panel__col">
                <KuikaSmallMediumText>Condition</KuikaSmallMediumText>
              </div>
            </div>
            <div className="kuika-right-panel__row" style={{ marginBottom: 8 }}>
              <div className="kuika-right-panel__col">
                <Comparison
                  action={this.props.action}
                  condition={this.props.condition}
                  onChange={this.props.onChange}
                  conditionType="action"
                />
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.ActionParameterFixedValueChanged ||
      changeReason === ESdChangeReason.WFStepMappingChange
    ) {
      return true;
    }
    return false;
  };
}

const actionCondition = withContext<IActionConditionPickerProps>(withSD<IActionConditionPickerProps>(ActionCondition));
export { actionCondition as ActionCondition };
